<template>
  <div class="container">
    <p>读者可以输入期刊的名称、ISSN、出版社等对期刊进行查找。</p>
    <img src="../../assets/images/newhelp/help24.png" alt="" />
  </div>
</template>
<script>
export default {
  name: "Page1",
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.container {
  padding: 75px;
  p,
  img {
    margin-bottom: 15px;
    font-size: 18px;
    max-width: 100%;
  }
  .red {
    color: #fa0000;
  }
}
</style>
